var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white opacity-100 flex flex-col items-center justify-center"},[_c('div',{staticClass:"loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-8 w-8 mb-4"})])
}]

export { render, staticRenderFns }